import { Route } from '@angular/router';
import { AppUrls } from '../../../../../../common/dto/app-urls';

export const FormsRoute: Route = {
  path: AppUrls.Dashboard._.Feedback._.Forms.relativeUrl,
  children: [
    {
      path: AppUrls.Dashboard._.Feedback._.Forms._.FormList.relativeUrl,
      pathMatch: 'full',
      loadComponent: () => import('./form-list/form-list.component').then(_ => _.FormListComponent),
    },
    {
      path: AppUrls.Dashboard._.Feedback._.Forms._.FormEditor.relativeUrl,
      loadComponent: () => import('./form-editor/form-editor.component').then(_ => _.FormEditorComponent),
    },
    {
      path: AppUrls.Dashboard._.Feedback._.Forms._.FormResponses.relativeUrl,
      loadComponent: () => import('./form-responses/form-responses.component').then(_ => _.FormResponsesComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Dashboard._.Feedback._.Forms._.FormList.relativeUrl,
    },
  ],
};
